import { default as ReactSelect, components } from "react-select";
import playerlogo from "../../assets/images/playerLogo_light.svg";
const PlayerOption = (props: any) => {
 // console.log(props.data);

  return (
    <div>
      <components.Option {...props}>
        <div className="flex gap-2 items-center ">
          <div className="relative ">
            <img loading="lazy"
              src={props?.data?.image || props?.data?.photo || playerlogo}
              alt=""
              className="object-cover min-w-12 w-12 h-12 rounded-full"
            />
            <div className="absolute top-[calc(100%-10px)]  w-[70%] left-[15%] bg-primaryYellow text-primary rounded-2xl h-[15px] p-0 m-0 text-sm text-center">
              <span className="leading-3">{props?.data?.level}</span>
            </div>
          </div>
          <div className="flex flex-col">
            <span>{props.label}</span>
            <span>{props?.data?.email || props?.data?.email_address}</span>
          </div>
        </div>
      </components.Option>
    </div>
  );
};

export default PlayerOption;
